// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_X3O","cls2":"TranslationModal-cls2_KMn TranslationModal-cls1_X3O"};